import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map, tap } from 'rxjs/operators';
import { DistributorService } from 'src/app/api/services/distributor.service';
import { HandlerService } from 'src/app/api/services/handler.service';
import * as fromRoot from '../../../core/state/core.state';
import { PathType } from '../../enums/path-type.enum';
import * as fromPath from './path.actions';

@Injectable()
export class PathEffects {
  updateTypeEffect$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromPath.updateType),
        map(action => action.pathType),
        tap((pathType: PathType) => {
          this.getHandlers(pathType);
        })
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private handlerService: HandlerService,
    protected store: Store<fromRoot.State>,
    private distributorService: DistributorService
  ) {}

  getHandlers(productCode: string): void {
    let distributorCode = this.distributorService.GetDistributorCode();
    this.handlerService.GetHandlers(productCode, distributorCode).subscribe(handlers => {
      this.store.dispatch(fromPath.updateHandlers({ handlers }));
    });
  }
}
